// src/pages/SchoolBankConfig.tsx
import { Pencil1Icon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetSchoolBankConfigQuery } from '../../../hooks/useGetSchoolBankConfigQuery';
import { setSchoolBankConfigData } from '../../../redux/slices/finance/schoolbankconfig';
import { routes } from '../../../routes';
import { SchoolBankConfigType } from '../../../types/Finance';

export const columnNamesMap_SchoolBankConfig: { [key: string]: string } = {
    bankName: 'Nome do Banco',
    bankDescription: 'Descrição do Banco',
    bankEntity: 'Entidade bancária',
    // status: 'Estado',
    // useBankClient: 'Usar cliente do banco ?',
    // useBankInstitute: 'Usar Instituto Banco ?',
    //statusString: 'Estado',
    // useBankClientString: 'Usar cliente do banco ?',
    // useBankInstituteString: 'Usar Instituto Banco ?',
};

export const SchoolBankConfig = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { data, status } = useGetSchoolBankConfigQuery({ PageNumber: currentPage, PageSize: 400 });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleCreateItem = (event: any): void => {
        navigate(routes.createSchoolBankConfig)
    }

    const handleUpdateItem = (schoolBankConfig: SchoolBankConfigType) => {

        dispatch(setSchoolBankConfigData(schoolBankConfig));
        navigate(routes.updateSchoolBankConfig)
    };

    const options = data?.items.map((schoolBankConfig: any) => [
        {
            label: 'Editar',
            onClick: (schoolBankConfig: SchoolBankConfigType) => handleUpdateItem(schoolBankConfig),
            icon: <Pencil1Icon />
        }
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() => <TableComponent
                columns={Object.keys(columnNamesMap_SchoolBankConfig)}
                items={data?.items.map(schoolBankConfig => {
                    return {
                        ...schoolBankConfig,
                        statusString: (schoolBankConfig.status ? 'Sim' : 'Não'),
                        useBankClientString: (schoolBankConfig.useBankClient ? 'Sim' : 'Não'),
                        useBankInstituteString: (schoolBankConfig.useBankInstitute ? 'Sim' : 'Não'),
                    }
                })}
                options={options}
                columnNamesMap={columnNamesMap_SchoolBankConfig}
                totalPages={data?.totalPages || 1}
                currentPage={currentPage}
                onPageChange={handlePageChange}
            />}
            handleClickCreate={data && data?.items && data?.items.length>0?undefined:handleCreateItem}
        />
    );
};

export default SchoolBankConfig;